<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="notice__page">
          <div class="complete" v-if="$Util.isEmpty(electUserList) || electUserList.length <= 0">
            <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img">
            <p class="complete__txt__type02">내역이 없습니다.</p>
          </div>
          <ul class="notice__page__ul" v-else>
            <li class="notice__page__li type_02" v-for="(item, index) in electUserList" :key="index"
                @click="item.unReadNoticeCount > 0 ? showManagerNoticeModal(item) : doLogin(item)">
              <div class="txt">
                <p>{{ item.companyName }} • {{ item.contactName }}</p>
                <p class="date">{{ item.companyAddress1 }} {{ item.companyAddress2 }}</p>
              </div>
              <div class="badge" v-show="item.unReadNoticeCount > 0">{{ item.unReadNoticeCount }}</div>
              <i class="i_right"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AccountSvc from '@/common/service/AccountSvc';

export default {
  data: function () {
    return {
      electUserList: [],
      params: {
        managerUserNo: this.$store.getters['account/getUserData'].managerUserNo || 0
      }
    }
  },
  computed: {
    managerDataState: function () {
      return this.$store.getters['account/getManagerData']
    }
  },
  created: function () {
    this.getElectUserList()
  },
  methods: {
    doLogin: async function (item) {
      const res = await AccountSvc.refreshElectUserData({userNo: item.userNo, managerUserNo: this.managerDataState.userNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        await this.$router.push('/main/home')
      }
    },
    showManagerNoticeModal: function (item) {
      this.$Util.modalPage('manager-notice-modal', {userNo: item.userNo, managerUserNo: this.managerDataState.userNo})
    },
    getElectUserList: async function () {
      const res = await this.$ElectSvc.getElectUserList({managerUserNo: this.managerDataState.userNo})
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        this.electUserList = entity
      }
    }
  }
}
</script>
